import { ready } from './lib/dom';
import { mobileMenu } from './components/mobileMenu';
import { desktopMenu } from './components/desktopMenu';
import { parallax } from './components/parallax';
import { forms } from './components/forms';
import { contactForm } from './components/contactForm';
import { gallery } from './components/gallery';
import { waves } from './components/waves';
import { waterLevels } from './components/waterLevels';

/**
 * Front-end entry point.
 *
 * Replaces the two WordPress-era bundles (theme.min.js and block-addons.js) and
 * the jQuery they were built on. Every component is a no-op on pages that lack
 * its markup, so one bundle serves all templates.
 *
 * Deliberately dropped:
 *   - jQuery + jquery-migrate — only ever used for querying and class toggling
 *   - rellax                  — replaced by components/parallax.ts
 *   - sal.js                  — no page carries a single `data-sal` attribute
 *   - wavify + GSAP/TweenMax  — replaced by components/waves.ts
 *   - Gravity Forms (8 scripts) — replaced by components/contactForm.ts
 */
ready(() => {
  mobileMenu();
  desktopMenu();
  forms();
  contactForm();
  gallery();
  parallax();
  waves();
  waterLevels();
});
